declare var HistoryUpdatePool: any;
//declare var signalR: any;
import * as signalR from "@microsoft/signalr"; //not build

window.SignalR = (function () {
    var connection: any;//signalR.HubConnection; //not build
    var config: ISignalRConfig;

    function start(conf: ISignalRConfig) {
        config = conf;
        connection = new signalR.HubConnectionBuilder()
            .withUrl("/account", {
                // accept any transport
                transport: signalR.HttpTransportType.WebSockets |
                    signalR.HttpTransportType.ServerSentEvents |
                    signalR.HttpTransportType.LongPolling,
                accessTokenFactory: () => config.accountToken
            })
            .withAutomaticReconnect()
            .build();
        connection.onreconnecting(() => {
            join();
        });
        subscribe();
        connection.start().then(() => {
            if (connection.state.toString() === "Connected")
                join();
        });
    }

    function join() {
        if (config.isAuthenticated) {
            connection.send("join", config.accountToken);
        }
    }

    function subscribe() {
        connection.on('RefreshToken', () => {
            var queryTokenUrl = '/api/signalr/account/refreshtoken?rnd=' + Math.random();
            $.get(queryTokenUrl, token => {
                config.accountToken = token;
                join();
            });

        });

        connection.on('AccountLogout', msg => {
            var logoutEvent = new CustomEvent('accountLogout');
            window.dispatchEvent(logoutEvent);
            window.location.reload();
        });

        connection.on('LogoutAll', msg => {
            var logoutEvent = new CustomEvent('accountLogout');
            window.dispatchEvent(logoutEvent);
            window.location.reload();
        });

        if (window.BettingCart?.notification?.NotifyPackageBetResult) {  
            connection.on('NotifyPackageBetResult', BettingCart.notification.NotifyPackageBetResult);
        }

        var isHistory = () => $('#page-content').attr('data-page') === 'history';
        connection.on('AccountBalanceChanged', (accountId: number, currencyCode: string, balance: number) => {
            var currentCurrency = window.globalAppSettings.currentUser.defaultBalance.currencyCode;
            if (currentCurrency.toUpperCase() !== currencyCode.toUpperCase())
                return;

            var notificationBalanceUpdateEvent = new CustomEvent<{
                balanceVal: number;
            }>('notificationBalanceUpdate', {
                detail: {
                    balanceVal: balance,
                },
            });

            window.dispatchEvent(notificationBalanceUpdateEvent);

            if (isHistory()) {
                HistoryUpdatePool.add();
            }
        });

        connection.on('AccountBonusesChanged', (accountId: number, bonuses: number) => {
            var notificationBonusesUpdateEvent = new CustomEvent<{
                bonusPoints: number;
            }>('notificationBonusesUpdate', {
                detail: {
                    bonusPoints: bonuses,
                },
            });

            window.dispatchEvent(notificationBonusesUpdateEvent);

            if (isHistory()) {
                HistoryUpdatePool.add();
            }
        });

        connection.on('AccountBetBalanceChanged', (accountId: number, betBalance: number) => {
            var notificationBetBalanceUpdateEvent = new CustomEvent<{
                betBalance: number;
            }>('notificationBetBalanceUpdate', {
                detail: {
                    betBalance
                },
            });

            window.dispatchEvent(notificationBetBalanceUpdateEvent);
        });

        connection.on('UnviewedBetsChanged', (accountId, unviewedBetCount: number) => {
            const selectors = {
                mnHistCount: '#mn-hist_count',
            };
            if (isHistory()) {
                HistoryUpdatePool.add();
            }
            else {
                (unviewedBetCount > 0) ? $(selectors.mnHistCount).text(unviewedBetCount).addClass('active') : $(selectors.mnHistCount).removeClass('active');
            }
        });

        connection.on('RedirectToLogout', () => {
            Ajax.getJson('/account/logout');
        });
    }

    return {
        start
    }
}());